import { OnInit, OnDestroy } from '@angular/core';
import { SubscriptionLike } from 'rxjs';
import { CookieService } from 'ngx-cookie';
import { FilterService } from './filter.service';
import { Promo, PromoService } from './promo.service';

export abstract class PromoSliderDefaultComponent implements OnInit, OnDestroy {
  items: Promo[] = [];
  subscription: SubscriptionLike;

  constructor(
    protected promoService: PromoService,
    protected filterService: FilterService,
    protected cookie: CookieService,
  ) {}

  public async ngOnInit() {
    if (typeof window === 'undefined') return;

    const activeTarget = this.cookie.get('target');
    const activeActivity = this.cookie.get('activity');
    const targetArr: string[] = [];
    if (activeTarget) targetArr.push(activeTarget);
    if (activeActivity) targetArr.push(activeActivity);

    try {
      this.items = await this.promoService.get(targetArr);
    } catch (e) {}

    this.subscription = this.filterService.changeActive.subscribe(async (target: any) => {
      const targetArray: string[] = [];
      if (this.filterService.activeTargetAudience) targetArray.push(this.filterService.activeTargetAudience._id);
      if (this.filterService.activeActivity) targetArray.push(this.filterService.activeActivity._id);
      try {
        this.items = await this.promoService.get(targetArray);
      } catch (e) {}
    });
  }

  public ngOnDestroy() {
    if (typeof window !== 'undefined') this.subscription.unsubscribe();
  }
}
